import styled from "styled-components";
import { Theme } from "../../../../../../../../../../types/Theme";
import lightIconImage from "../../../../../../../../../../assets/images/light/lightImage.png";
import darkIconImage from "../../../../../../../../../../assets/images/dark/darkImage.png";
import { THEME_TYPES } from "../../../../../../../../../../constants";

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    transition: visibility 0s, opacity 0.3s linear;
`;

interface ContentProps {
    theme: Theme,
}

export const ModalContent = styled.div<ContentProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
    min-width: 400px;
    background-color: ${props => props.theme.backgroundCard};
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
`;

export const ModalHeader = styled.div<ContentProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    h1 {
        font-size: 28px;
        padding: 10px;
        text-align: center;
        font-weight: 600;
        line-height: 30px;
        color: ${props => props.theme.primaryColor};
    }

    div {
        &:hover {
            cursor: pointer;
        }
    }
`;

export const ModalBody = styled.div<ContentProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;

    button {
        width: 50%;
        background-color: ${props => props.theme.primaryColor};
    }
`;

export const GridBlockIcon = styled.div`
    display: flex;

    div + div {
        margin-left: 20px;
    }
`;

export const BlockIcon = styled.div``;

export const TitleIcon = styled.span`
    font-size: 18px;
    color: ${props => props.theme.textColor};
`;

export const ImageIcon = styled.img.attrs(props => ({
	src: props.theme.type === THEME_TYPES.DARK ? darkIconImage : lightIconImage,
	alt: "Adicionar icon light ou dark"
}))`
    width: 70px;
    border-radius: 8px;
    height: auto;
`;
